import { DefaultButton, IButtonStyles, mergeStyleSets } from "@bps/fluent-ui";

interface SendFormButtonProps {
  setSendDialogVisible: (visible: boolean) => void;
  styles?: IButtonStyles | undefined;
  value: string | undefined;
}

export const SendFormButton: React.FC<SendFormButtonProps> = ({
  setSendDialogVisible,
  styles,
  value
}) => {
  return (
    <DefaultButton
      styles={mergeStyleSets(styles, {
        root: {
          minWidth: 114,
          height: 32
        }
      })}
      disabled={!value}
      onClick={() => setSendDialogVisible(true)}
    >
      Send form
    </DefaultButton>
  );
};
